<template>
  <p-input-text
    v-if="withText"
    :value="modelValue"
    size="small"
    @input="$emit('update:modelValue', $event.target.value)"
  />
  <input
    type="color"
    :value="modelValue"
    :class="{
      'ml-2 flex-shrink-0': withText
    }"
    @change="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: null
  },
  withText: {
    type: Boolean,
    default: false
  }
})
</script>
